import CourseController from '../diagrams/course.controller';

class ScqDiagramController extends CourseController {

  constructor(courseService, diagramService, $translate) {
    'ngInject';

    super(courseService, diagramService, $translate);
    this.diagramId = this.diagramService.guid();
  }

  $postLink() {
    setTimeout(() => this.diagramService.initSCQDiagram(this.diagramId, true), 1000);
  }

  submit() {
    const boxesWithIncorectAnswers = $(`#${this.diagramId} .answer__incorrect`);
    const boxesWithCorectAnswers = $(`#${this.diagramId} .answer__correct`);
    this.submited = true;
    if (boxesWithCorectAnswers.length === 4) {
      this.courseService.play('buttonClick');
      this.diagramComplete = true;
      this.diagramService.disableSCQDiagram(this.diagramId);
      setTimeout(() => this.courseService.play('exerciseComplete'), 500);
      this.finishExercise();
    } else {
      this.courseService.play('wrongAnswer');
    }

  }

  hint() {
    this.courseService.play('buttonClick');
    const selector = `#${this.diagramId} .answer__incorrect`;
    $(selector).css('border-color', 'red');
    setTimeout(() => $(selector).css('border-color', 'white'), 200);
  }

}

export default ScqDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/scq-diagram-dnd-framework/scq-diagram-dnd-framework.controller.js